import { startOfDay, subDays } from 'date-fns';
import { NoticeModel } from '~/components/Support/Support.hooks';
import { sharedDateTimer } from '~/components/Util';

export const getTimestampForNotice = (): number => {
  const timestamp = Number(localStorage.getItem('NOTICE_LAST_TIMESTAMP') || 0);
  const minTimestamp = startOfDay(subDays(sharedDateTimer.now, 7)).getTime();
  return minTimestamp <= timestamp ? timestamp : minTimestamp;
};

export const setTimestampForNotice = () => {
  const timestamp = sharedDateTimer.now.getTime();
  localStorage.setItem('NOTICE_LAST_TIMESTAMP', String(timestamp));
};

export const checkNoticeItemNewBadge = ({ id, registered, newBadge }: NoticeModel) => {
  const checkedInfo = JSON.parse(localStorage.getItem('NOTICE_ITEM_CHECKED') || '{}');

  if (!newBadge) {
    delete checkedInfo[`${id}`];
    localStorage.setItem('NOTICE_ITEM_CHECKED', JSON.stringify(checkedInfo));
    return false;
  }

  if (checkedInfo[`${id}`]) return false;

  const now = sharedDateTimer.now;
  const minTimestamp = startOfDay(subDays(now, 7)).getTime();
  return registered >= minTimestamp;
};

export const setCheckedForNoticeItem = (id: string) => {
  const checkedInfo = JSON.parse(localStorage.getItem('NOTICE_ITEM_CHECKED') || '{}');
  localStorage.setItem('NOTICE_ITEM_CHECKED', JSON.stringify({ ...checkedInfo, [id]: true }));
};
